<template>
  <div class="my_coupon_page">
    我的优惠券
    <div class="coupon_content">
      <el-tabs v-model="userStatus" type="card" @tab-click="getData(1)">
        <el-tab-pane label="未使用" name="UN_USE"></el-tab-pane>
        <el-tab-pane label="已使用" name="USED"></el-tab-pane>
        <el-tab-pane label="已失效" name="EXPIRED"></el-tab-pane>
      </el-tabs>
      <div class="content" v-if="couponList.length > 0">
        <el-card
          v-for="(item, index) of couponList"
          :key="index"
          class="card_box"
        >
          <div slot="header" class="clearfix">
            <span class="title">{{ item.couponPrice }}元</span>
            <el-button
              style="float: right; padding: 3px 0; color: #00a0e9"
              type="text"
              v-if="userStatus === 'UN_USE'"
              @click="toUse(item)"
              >去使用</el-button
            >
          </div>
          <div class="subtitle">
            使用规则：
            {{ item.couponLimitprice }}
            失效时间：
            {{ item.endTime }}
          </div>
        </el-card>
      </div>
      <div class="noData" v-else>
        <span class="tips">~暂时没有可用的优惠券哦~</span>
      </div>
    </div>
  </div>
</template>

<script>
import { myCouponListApi } from "../../api/index";
export default {
  data() {
    return {
      userStatus: "UN_USE",
      couponList: [],
      loading: false,
    };
  },
  created() {},
  activated() {
    this.getData(1);
  },
  methods: {
    getData(pageNo = 1) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      myCouponListApi({
        userStatus: this.userStatus,
        pageNo: 1,
        pageSize: 99,
      })
        .then((res) => {
          if (res.resultStatus) {
            const result = res.resultData.records || [];
            this.couponList = result;
          } else {
            this.couponList = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toUse(item) {
      this.$store.commit("UPDATE_USER_COUPON", {
        ...item
      });
      this.$store.commit("UPDATE_ACTIVE_MENU", "1-1");
      this.$router.push({
        name: "orderPage",
      });
    },
  },
};
</script>

<style lang="less">
.my_coupon_page {
  width: 100%;
  padding: 10px 10px 10px 20px;
  .coupon_content {
    margin-top: 12px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #00a0e9;
  }
  .subtitle {
    font-size: 13px;
    color: #333;
  }
  .banner {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .card_box {
    margin-bottom: 12px;
  }
  .noData {
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tips {
      font-size: 13px;
      color: #333;
    }
  }
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>